import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { comics, featuredComicIds } from '@/mocks/comics';

const featuredComics = featuredComicIds.map((id) => comics.find((c) => c.id === id)!);

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % featuredComics.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const comic = featuredComics[current];

  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={comic.cover}
          alt={comic.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-background-50"></div>
      </div>

      <div className="relative z-10 h-full flex flex-col justify-end pb-16 md:pb-20">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-4xl">
            <div className="flex flex-wrap gap-2 mb-4">
              {comic.tags.map((tag) => (
                <span key={tag} className="px-3 py-1 rounded-full text-xs font-medium bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 whitespace-nowrap">
                  {tag}
                </span>
              ))}
              <span className={`px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
                comic.status === '连载中' ? 'bg-primary-500/90 text-background-50' : 'bg-secondary-500/90 text-background-50'
              }`}>
                {comic.status}
              </span>
            </div>

            <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-3">
              {comic.title}
            </h1>
            <p className="text-background-200/90 text-sm md:text-base max-w-xl mb-6 line-clamp-2">
              {comic.description}
            </p>

            <div className="flex flex-wrap items-center gap-3 md:gap-4">
              <Link
                to={`/comic/${comic.id}`}
                className="px-6 py-2.5 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                立即阅读
              </Link>
              <span className="text-background-200/80 text-sm">
                <i className="ri-star-fill text-accent-500 mr-1"></i>
                {comic.rating} 分
              </span>
              <span className="text-background-200/80 text-sm">
                <i className="ri-eye-line mr-1"></i>
                {(comic.views / 10000).toFixed(0)}万 阅读
              </span>
              <span className="text-background-200/80 text-sm">
                更新至 {comic.chapters[0].num} 话
              </span>
            </div>
          </div>
        </div>

        <div className="flex justify-center gap-2 mt-8">
          {featuredComics.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrent(idx)}
              className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                idx === current
                  ? 'w-6 bg-primary-500'
                  : 'bg-background-50/50 hover:bg-background-50/80'
              }`}
              aria-label={`切换到第 ${idx + 1} 张`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
}